import { paths } from 'src/routes/paths';

import axios from 'src/utils/axios';
import { logger } from 'src/utils/logger';

import { STORAGE_KEY } from './constant';

// ----------------------------------------------------------------------
let timer = null;

export function jwtDecode(token) {
  try {
    if (!token) return null;

    const parts = token.split('.');
    if (parts.length < 2) {
      throw new Error('Invalid token!');
    }

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    return decoded;
  } catch (error) {
    logger.error('Error decoding token:', error);
    throw error;
  }
}

// ----------------------------------------------------------------------

export function isValidToken(accessToken) {
  if (!accessToken) {
    return false;
  }

  try {
    const decoded = jwtDecode(accessToken);

    if (!decoded || !('exp' in decoded)) {
      return false;
    }

    const currentTime = Date.now() / 1000;

    return decoded.exp > currentTime;
  } catch (error) {
    logger.error('Error during token validation:', error);
    return false;
  }
}

// ----------------------------------------------------------------------

export function isTokenExpired(token) {
  const decoded = jwtDecode(token);
  const currentTime = Date.now();
  const timeLeft = decoded.exp * 1000 - currentTime;
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }

  timer = setTimeout(() => {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
      if (window.location.pathname !== paths.auth.signIn) {
        window.location.href = paths.auth.signIn;
      }
    } catch (error) {
      logger.error('Error during token expiration:', error);
      throw error;
    }
  }, timeLeft);
}

// ----------------------------------------------------------------------

export async function setSession(accessToken) {
  try {
    if (accessToken) {
      sessionStorage.setItem(STORAGE_KEY, accessToken);

      axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

      const decodedToken = jwtDecode(accessToken); // ~3 days by minimals server

      if (decodedToken && 'exp' in decodedToken) {
        isTokenExpired(decodedToken);
      } else {
        throw new Error('Invalid access token!');
      }
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
      delete axios.defaults.headers.common.Authorization;
    }
  } catch (error) {
    logger.error('Error during set session:', error);
    throw error;
  }
}
